// composables/useSort.js
import { ref } from 'vue';

export function useSort(defaultKey = '', defaultOrder = 'ASC') {
  const sortKey = ref(defaultKey);
  const sortOrder = ref(defaultOrder);

  const sortIndicator = (key) => {
    if (sortKey.value !== key) return '';
    return sortOrder.value === 'ASC' ? '▲' : '▼';
  };

  const sortBy = (key, callback) => {
    if (sortKey.value === key) {
      sortOrder.value = sortOrder.value === 'ASC' ? 'DESC' : 'ASC';
    } else {
      sortKey.value = key;
      sortOrder.value = 'ASC';
    }
    if (typeof callback === 'function') {
      callback(); // fetchItems 등 호출
    }
  };

  return {
    sortKey,
    sortOrder,
    sortIndicator,
    sortBy
  };
}
